import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {TaskData} from '@nachdigal';
import {TaskDataService} from '../service/task-data.service';

@Injectable()
export class TaskDataResolver implements Resolve<unknown> {
    constructor(private readonly taskDataService: TaskDataService) {
    }

    public resolve(route: ActivatedRouteSnapshot): Observable<TaskData> {
        const taskId = route.paramMap.get('taskId');
        return this.taskDataService.loadTaskData(taskId);
    }
}
